<layout-container>
  <div class="terms-screen" id="terms-screen">
    <form
      [formGroup]="termsForm"
      [ngClass]="{ loading: loading }"
      (ngSubmit)="sendAgreement(termsForm)"
      name="termsForm"
      novalidate
    >
      <div class="terms-screen-container">
        <div class="terms-screen">
          @if (termsContent.Header) {
            <h2 class="font-bold max-md:typography-sub-header" data-test-id="main-header">{{ termsContent.Header }}</h2>
          }

          <div class="terms-agreement-content">
            @for (section of termsContent.Sections; track section) {
              <div class="terms-agreement-content-section">
                @if (section.Header) {
                  <h5 class="section-header font-bold my-0">{{ section.Header }}</h5>
                }
                @for (paragraph of section.Paragraphs; track paragraph) {
                  <p [innerHTML]="paragraph" class="section-paragraph"></p>
                }
              </div>
            }
          </div>
          <div class="agreements-checkboxes flex flex-col flex-between-start gap-12">
            @for (checkbox of termsContent.Checkboxes; track checkbox) {
              <div class="mat-checkbox-container">
                <mat-checkbox [formControlName]="checkbox.Name" color="accent">{{ checkbox.Label }}</mat-checkbox>
                <small [innerHTML]="checkbox.SmallText"></small>
                @if (checkbox.Mandatory) {
                  <validation-messages
                    [field]="termsForm.get(checkbox.Name)"
                    [texts]="{ required: checkbox.MandatoryText || 'This checkbox is required.' }"
                    messages="['required']"
                  ></validation-messages>
                }
              </div>
            }
          </div>
          <div class="terms-screen-actions flex flex-start-center">
            <button color="accent" mat-flat-button type="submit">Save</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</layout-container>
